import React, { useContext, useEffect } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";

import Main from "./Main";
import routes from "../routes";
import Header from "components/header/Header";
import Sidebar from "components/sidebar/Sidebar";
import ChatPresence from "components/ChatPresence";
import { SidebarContext } from "context/SidebarContext";

import Page404 from "../pages/404";

const Layout = () => {
  const { isSidebarOpen, closeSidebar } = useContext(SidebarContext);
  let location = useLocation();
  // const adminInfo = localStorage.getItem("adminInfo")
  //   ? JSON.parse(localStorage.getItem("adminInfo"))
  //   : null;
  // const profile = adminInfo?.profile;

  useEffect(() => {
    closeSidebar();
  }, [location]);

  return (
    <div
      className={`flex h-screen bg-gray-50 dark:bg-gray-900 ${
        isSidebarOpen && "overflow-hidden"
      }`}
    > 
      <ChatPresence />
      <Sidebar />

      <section className="home-section">
        <div className="flex flex-col flex-1 w-full bg-gray-50 dark:bg-gray-900">
          <Header />
          <Main>
            <Switch>
              {routes.map((route, i) => {
                return route.component ? (
                  <Route
                    key={i}
                    exact={true}
                    path={`${route.path}`}
                    render={(props) => <route.component {...props} />}
                  />
                ) : null;
              })}
              <Redirect exact from="/" to="/dashboard" />
              <Route component={Page404} />
            </Switch>
          </Main>
        </div>
      </section>
    </div>
  );
};

export default Layout;
